import { memo } from 'react';
import type { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

import { Modal } from './Modal';
import type { ModalsType } from 'types';
import { Button } from 'components/common';
import { TextInput } from 'components/common/Inputs';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> extends ModalsType {
  title: string;
  fields?: {
    label: string;
    name: string;
    required: boolean;
    placeholder: string;
    type: string;
    pattern?: RegExp;
  }[];
  register: UseFormRegister<T>;
  errors?: FieldErrors<T>;
}

export const MultilangTextModal = memo(({ open, onClose, title, register, fields, errors }: Props<FieldValues>) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={title}
      modalNumber={2}
      content={
        <div className="grid grid-cols-1 gap-8 w-full max-h-[50svh] min-h-20 overflow-y-auto px-5">
          {fields?.map((field, index) => (
            <TextInput
              key={field.name}
              autoFocus={index === 0}
              label={t(`common.placeholder.${field.label}`)}
              register={register}
              registerName={field.name}
              placeholder={t(`common.placeholder.${field.name}`)}
              className="w-full"
              registerProps={{
                required: field.required && t('common.required'),
                pattern: field.pattern && {
                  value: field.pattern,
                  message: 'Invalid input',
                },
              }}
              error={errors?.[field.name]}
            />
          ))}
        </div>
      }
      footer={
        <div className="grid w-full grid-cols-3 gap-4">
          <Button onClick={onClose} type="button">
            {t('common.close')}
          </Button>
          <Button onClick={onClose} className="col-start-3" isSecondary>
            {t('common.confirm')}
          </Button>
        </div>
      }
    />
  );
});
